import { useItemEdsDateFormatted } from "@coworker/apprestructured/src/shared/hooks/item/useItemEdsDateFormatted";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./item-eds.module.css";
import React from "react";

interface ItemEDSProps {
  itemNo: string;
}

export const ItemEds = ({ itemNo }: ItemEDSProps) => {
  const { isLoading, edsDate } = useItemEdsDateFormatted(itemNo);

  return (
    <React.Fragment>
      {isLoading && <FixaSkeleton width="50%" height="16px" />}
      {!isLoading && edsDate && (
        <FixaText
          className={styles["item-eds-text"] || ""}
          textStyle={"Body.S"}
        >
          EDS: {edsDate}
        </FixaText>
      )}
    </React.Fragment>
  );
};
